import { createFileRoute } from '@tanstack/react-router'
import { CallsView } from '@/components/views/CallsView'
import { useResourcesStore } from '@/stores/resources'

export const Route = createFileRoute('/_auth/calls')({
  beforeLoad: () => ({ title: 'Calls' }),
  component: CallsView,
  loader: () => useResourcesStore.getState().actions.fetchResources(),
})
